import './_controller.scss';
import ControllerTitle from "./controller-title/controller-title";
import MiniMap from "./mini-map/mini-map";
import Toolbar from "./toolbar/toolbar";
import Filter from "./filter/filter";
import ScreenshotToolbar from "./screenshot-toolbar/screenshot-toolbar";
import Hotspots from "./hotspots/hotspots";
import VStore from "../../store";

const Controller = () => {
    const {screenshotMode} = VStore();

    return <div id='controller' className='controller hide'>
        <ControllerTitle/>
        <div style={{visibility: screenshotMode ? 'hidden' : 'visible'}}>
            <MiniMap/>
            <Toolbar/>
            <Filter/>
        </div>
        <div style={{visibility: screenshotMode ? 'visible' : 'hidden'}}>
            <ScreenshotToolbar/>
        </div>
        <Hotspots/>
    </div>
}

export default Controller;
